import React, { Component } from "react";
import { connect } from "react-redux";
import { Select, Option, StepItem, Alert } from "../Shared";
import { findNextStep, onStepOptionSelect } from "./stepHelpers";
import * as STEP_KEYS from "../../consts";
import { specialtyTypeSelector } from "../../selectors";
import {
  updateAppointmentDetail,
  updateDataSource,
  goToStep,
  goBackToStep,
  completeStep,
  toggleControl
} from "../../actions";
import { SPECIALTY_TYPE } from "../../consts";

class SpecialtyTypeSelect extends Component {
  componentDidMount = () => {
    if (this.props.value !== "" && this.props.current) {
      this.handleSelect(this.props.value);
    }
  };

  shouldComponentUpdate = (nextProps, nextState) => {
    if (
      this.props.value === nextProps.value &&
      this.props.current === nextProps.current &&
      this.props.isOpen === nextProps.isOpen
    ) {
      return false;
    }
    return true;
  };

  toggleControl = open => {
    this.props.toggleControl(SPECIALTY_TYPE, open);
  };

  handleSelect = value => {
    if (this.props.value === value && !this.props.current) {
      this.toggleControl(false);
      return;
    }
    const { options, updateDataSource } = this.props;
    const { appointmentTypes } = options.find(
      option => option.specialtyTypeId === value
    );
    updateDataSource("appointmentTypes", appointmentTypes);
    onStepOptionSelect(
      this.props,
      value,
      STEP_KEYS.SPECIALTY_TYPE,
      findNextStep(STEP_KEYS.SPECIALTY_TYPE)
    );
  };

  renderOptions = () => {
    if (this.props.options.length === 0) {
      return <Alert message="No service available" />;
    }
    return this.props.options.map(specialtyType => {
      return (
        <Option
          key={specialtyType.specialtyTypeId}
          label={specialtyType.name}
          value={specialtyType.specialtyTypeId}
          onClick={() => this.handleSelect(specialtyType.specialtyTypeId)}
          selected={specialtyType.specialtyTypeId === this.props.value}
        >
          {specialtyType.name}
        </Option>
      );
    });
  };

  render() {
    const { autoSelect, hintText, isOpen, text, value } = this.props;

    return !autoSelect ? (
      <StepItem>
        {hintText}
        <Select
          open={isOpen}
          text={text}
          value={value}
          placeholder="[select service]"
          onToggle={open => this.toggleControl(open)}
          reload={this.props.reload}
        >
          {this.renderOptions()}
        </Select>
      </StepItem>
    ) : null;
  }
}

export default connect(specialtyTypeSelector, {
  toggleControl,
  updateAppointmentDetail,
  updateDataSource,
  goToStep,
  goBackToStep,
  completeStep
})(SpecialtyTypeSelect);



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/SpecialtyTypeSelect.js